import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../Unit.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from './metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function arrayIterator(array) {
  return new (arrayIterator$1())(array);
}
function booleanArray(size) {
  var tmp0 = 'BooleanArray';
  // Inline function 'withType' call
  var array = fillArrayVal(Array(size), false);
  array.$type$ = tmp0;
  // Inline function 'kotlin.js.unsafeCast' call
  return array;
}
function fillArrayVal(array, initValue) {
  var inductionVariable = 0;
  var last = array.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      array[i] = initValue;
    }
     while (!(i === last));
  return array;
}
function charArray(size) {
  var tmp0 = 'CharArray';
  // Inline function 'withType' call
  var array = new Uint16Array(size);
  array.$type$ = tmp0;
  // Inline function 'kotlin.js.unsafeCast' call
  return array;
}
function charArrayOf(arr) {
  var tmp0 = 'CharArray';
  // Inline function 'withType' call
  var array = new Uint16Array(arr);
  array.$type$ = tmp0;
  // Inline function 'kotlin.js.unsafeCast' call
  return array;
}
var arrayIterator$1Class;
function arrayIterator$1() {
  if (arrayIterator$1Class === VOID) {
    class $ {
      constructor($array) {
        this.p5_1 = $array;
        this.o5_1 = 0;
      }
      v1() {
        return !(this.o5_1 === this.p5_1.length);
      }
      w1() {
        var tmp;
        if (!(this.o5_1 === this.p5_1.length)) {
          var _unary__edvuaz = this.o5_1;
          this.o5_1 = _unary__edvuaz + 1 | 0;
          tmp = this.p5_1[_unary__edvuaz];
        } else {
          throw NoSuchElementException().f2('' + this.o5_1);
        }
        return tmp;
      }
    }
    initMetadataForClass($);
    arrayIterator$1Class = $;
  }
  return arrayIterator$1Class;
}
//region block: exports
export {
  arrayIterator as arrayIterator3lgwvgteckzhv,
  booleanArray as booleanArray2jdug9b51huk7,
  charArrayOf as charArrayOf27f4r3dozbrk1,
  charArray as charArray2ujmm1qusno00,
};
//endregion

//# sourceMappingURL=arrays.mjs.map
